import PrintQcm from './renderers/PrintQcm';
import PrintSaisie from './renderers/PrintSaisie';
import PrintVraiFaux from './renderers/PrintVraiFaux';
import PrintAssociation from './renderers/PrintAssociation';
import PrintEnonce from './helpers/PrintEnonce';
import { isVraiFaux, isTableExercise, estImagePorteuse } from './helpers/groupQuestions';

/**
 * Dispatcher : route un payload TanoEd vers le renderer print approprié.
 *
 * Ordre de détection (important) :
 *   1. V/F : type 'qcm' + un `elements_additionnels.elements[]` de type 'table'
  *      (vraiFaux OU générique colonnesLibres sans choix) → PrintVraiFaux
 *   2. 'qcm' standard → PrintQcm
 *   3. 'texte' → PrintSaisie
 *   4. Types non supportés Phase 1 (relier, ordonner, classer, texte_trou,
 *      programme_construction) → card grise "Phase 2/3"
 *
 * Les prédicats isVraiFaux / isTableExercise sont partagés avec
 * `groupQuestions` : les tableaux génériques (colonnesLibres…) suivent le même
 * routage que les V/F, en single comme en groupé.
 */

const UnsupportedPlaceholder = ({ num, type, subType }) => {
    const label = subType ? `${type}/${subType}` : type;
    return (
        <div className="ep-exo ep-exo-unsupported">
            <span className="ep-exo-num">{num}</span>
            <p className="ep-exo-consigne">
                Cet exercice ({label}) sera imprimable dans une prochaine version.
            </p>
        </div>
    );
};

const PrintExo = ({ payload, num, saisieMode = 'sur_la_feuille', reponseLibre = false }) => {
    if (!payload) return null;
    // Question EvalNat image-porteuse : la capture contient TOUT (énoncé,
    // consigne, choix) → pastille numéro + image seule. Ni consigne, ni choix,
    // ni même le texte d'énoncé (souvent redondant avec la capture) : texte=""
    // ne laisse passer que les éléments (l'image injectée par l'adaptateur).
    if (estImagePorteuse(payload)) {
        return (
            <div className="ep-exo">
                <span className="ep-exo-num">{num}</span>
                <PrintEnonce texte="" elements={payload.elements_additionnels?.elements} />
            </div>
        );
    }
    if (isVraiFaux(payload) || isTableExercise(payload)) return <PrintVraiFaux payload={payload} num={num} saisieMode={saisieMode} reponseLibre={reponseLibre} />;
    if (payload.type === 'qcm') return <PrintQcm payload={payload} num={num} saisieMode={saisieMode} reponseLibre={reponseLibre} />;
    if (payload.type === 'texte') return <PrintSaisie payload={payload} num={num} saisieMode={saisieMode} />;
    if (payload.type === 'association') {
        const sub = payload.contenu?.subType;
        // Tous les sous-types d'association supportés (Phase 2 + Phase 3).
        if (
            sub === 'relier'
            || sub === 'ordonner'
            || sub === 'classer'
            || sub === 'texte_trou'
            || sub === 'placer_points'
            || sub === 'placer_points_2d'
            || sub === 'programme_construction'
            || sub === 'placer_aiguilles'
        ) {
            return <PrintAssociation payload={payload} num={num} saisieMode={saisieMode} />;
        }
    }
    return (
        <UnsupportedPlaceholder
            num={num}
            type={payload.type || 'inconnu'}
            subType={payload.contenu?.subType}
        />
    );
};

export default PrintExo;
